module.exports = __webpack_public_path__ + "img/icon_short_economic_availability.8f147eb3.svg";